import styled from 'styled-components';
import buttonStyle from '../utils/buttonStyle';

export default styled.button`
  ${props => buttonStyle(props)};
`;
